import { GoogleOAuthProvider } from '@react-oauth/google';
import { Provider } from 'react-redux';
import { store } from '../store';
import '../styles/globals.css';
import { theme } from '../styles/theme';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { useEffect } from 'react';
import { useRouter } from 'next/router';
import Chatbot from '../components/Chatbot';

function MyApp({ Component, pageProps }) {
  const router = useRouter();
  useEffect(() => {
    // Remove the server-side injected CSS.
    const jssStyles = document.querySelector('#jss-server-side');
    if (jssStyles) {
      jssStyles.parentElement.removeChild(jssStyles);
    }

    // Restore user from localStorage
    const savedUser = localStorage.getItem('user');
    if (savedUser) {
      try {
        store.dispatch({ type: 'SET_USER', payload: JSON.parse(savedUser) });
      } catch (e) {
        console.error("Failed to parse user from localStorage", e);
      }
    }
  }, []);
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <GoogleOAuthProvider clientId={process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID}>
          <Component {...pageProps} />
          {!router.pathname.startsWith('/admin') && <Chatbot />}
        </GoogleOAuthProvider>
      </ThemeProvider>
    </Provider>
  );
}

export default MyApp;
